import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useState } from "react";
import Slider from "react-slick";
import img from "../../assets/images/flat.jpg"
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";


const Appartment_rent = ({properties,loading,error}) => {
  console.log(" new proppprrr==>",properties)
  console.log("Received properties:", properties, "Type:", typeof properties);

  const navigate = useNavigate();
  // const [properties] = useState(propertiesData);

  // Custom Arrow Components
  const PrevArrow = ({ onClick }) => (
    <div
      onClick={onClick}
      className="absolute top-1/2 -left-6 transform -translate-y-1/2 cursor-pointer bg-[#54BD95] text-white p-2 rounded-full shadow-lg"
    >
      <ChevronLeft size={20} className="text-white" />
    </div>
  );

  const NextArrow = ({ onClick }) => (
    <div
      onClick={onClick}
      className="absolute top-1/2 -right-6 transform -translate-y-1/2 cursor-pointer bg-[#54BD95] text-white p-2 rounded-full shadow-lg"
    >
      <ChevronRight size={20} className="text-white" />
    </div>
  );

  const settings = {
    dots: false,
    infinite: properties.length > 1,
    speed: 300,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  const handleNavigate = (id) => {
    navigate(`/appartment_details/${id}`);
  };

  return (
    <>
    
      <div className="text-end px-6 mx-14 mt-4">
        <Link to="/appartment_for_rent">
          <button className="px-4 py-2 bg-[#54BD95] text-white font-semibold rounded hover:bg-[#3a8f70] transition duration-200">
            Show More
          </button>
        </Link>
      </div>
      <div className="relative px-4 maindev mx-16 mt-8">
        <Slider {...settings}>
          {properties?.map((property) => (
            <div key={property._id} className="p-6">
              <div
                className="bg-white shadow-lg rounded-lg overflow-hidden max-w-sm mx-auto cursor-pointer transition-transform transform hover:scale-105"
                onClick={() => handleNavigate(property._id)}
              >
                <img
                  src={property.mainImage}
                  alt={property.name}
                  className="w-full h-48 object-cover"
                />
                <div className="p-4">
                  <p className="text-gray-800 font-bold text-start text-sm mb-3">{`${property.bhk} BHK`}</p>
                  <p className="text-gray-600 text-sm text-start mb-3">
                    {`Price ₹ ${property.price}` }
                  </p>
                  <p className="text-gray-600 text-sm text-start mb-3">{`Location: ${property.address}`}</p>
                  <div className="mt-4">
                    <button className="w-full bg-[#54BD95] text-white font-semibold py-2 rounded-lg hover:bg-green-600">
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default Appartment_rent;
